export default [
    {
        path: '/admin/pension-rate',
        name: 'pension-rate',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/pension-rate/index.vue')
    }
]